import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL, NUMBER_ADMIN } from "../../../../config/config";
import { Mail, Phone,  CalendarDays, Award } from 'lucide-react'
import { OrbitProgress } from "react-loading-indicators";
import FadeIn from "../../../../views/Theme/FadeIn";


export default function ProfilUser() {
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/auth/me`, { withCredentials: true })
      .then(res => {
        console.log("Réponse API :", res.data); //  debug
        setUser(res.data); // car l'API renvoie directement l'objet user
      })
      .catch(err => console.error(err));
  }, []);

  if (!user) {
    return <div className="text-center mt-20 py-8 text-gray-400"><OrbitProgress variant="track-disc" color="#125f69ff" size="small" text="Chargement..." textColor="#086300ff" /></div>
  }

  // const logout =()=>{
  //     axios.post(`${API_BASE_URL}/auth/logout`, { withCredentials: true })
  // }

  return (
    <>
    <FadeIn delay={300}> 
    <div className="max-w-screen-xl px-4 mx-auto 2xl:px-0 py-8">
     <div className="flex min-h-screen w-full items-center justify-center -mt-20 p-1 dark:bg-gray-900">
      <div className="w-full max-w-4xl   bg-white shadow-lg dark:bg-gray-800 rounded-t-lg">
      <div className="h-3 w-full rounded-b rounded-full bgC"></div>
              <div className="relative flex flex-col items-center justify-center text-center ">
                <div className="relative z-10 mt-6">
                  <svg
                    className="w-28 h-28 text-red-800 dark:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12.4472 2.10557c-.2815-.14076-.6129-.14076-.8944 0L5.90482 4.92956l.37762.11119c.01131.00333.02257.00687.03376.0106L12 6.94594l5.6808-1.89361.3927-.13363-5.6263-2.81313Z" />
                    <path d="M5 10V6.74803l.70053.20628L7 7.38747V10c0 .5523-.44772 1-1 1s-1-.4477-1-1Zm3-1c0-.42413.06601-.83285.18832-1.21643l3.49538 1.16514c.2053.06842.4272.06842.6325 0l3.4955-1.16514C15.934 8.16715 16 8.57587 16 9c0 2.2091-1.7909 4-4 4-2.20914 0-4-1.7909-4-4Z" />
                    <path d="M14.2996 13.2767c.2332-.2289.5636-.3294.8847-.2692C17.379 13.4191 19 15.4884 19 17.6488v2.1525c0 1.2289-1.0315 2.1428-2.2 2.1428H7.2c-1.16849 0-2.2-.9139-2.2-2.1428v-2.1525c0-2.1409 1.59079-4.1893 3.75163-4.6288.32214-.0655.65589.0315.89274.2595l2.34883 2.2606 2.3064-2.2634Z" />
                  </svg>
                </div>
                <div className="relative z-10 mt-6">
                  <div className="flex flex-wrap justify-center gap-2">
                    <h1 className="text-2xl font-bold text-gray-700 dark:text-gray-300">{user.name}</h1>
                    <h1 className="text-2xl font-bold text-gray-700 dark:text-gray-300">{user.subname}</h1>
                    <h1 className="text-2xl font-bold text-gray-700 dark:text-gray-300">{user.surname}</h1>
                  </div>
                  <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                    Numéro ID: {user.id}-mksp/25
                  </p>
                </div>
                <div className="mt-4 flex flex-wrap justify-center gap-2">

                  {/* <span className="inline-flex items-center rounded-full bg-purple-200 px-2.5 py-0.5 text-xs font-medium text-purple-800 dark:bg-purple-800 dark:text-purple-200">
                    <GraduationCap className="mr-1 h-3 w-3" /> Computer Science
                  </span> */}
                </div>
              </div>


        {/* Main Content Grid */}
        <div className=" pt-16 md:pt-6">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-1">
            <div className="col-span-full border bg-white p-4 shadow-sm dark:border-gray-900 dark:bg-gray-800 md:col-span-1 dark:bg-[url(https://img2.wallspic.com/crops/1/2/2/0/6/160221/160221-whatsapp-blue-green-la_purete_de_la_couleur-turquoise-1080x1920.jpg)] ...">
              <h2 className="mb-4 text-lg font-semibold text-gray-900 dark:text-gray-50">Coordonnées</h2>
              <div className="grid gap-2 text-sm text-gray-700 dark:text-gray-300">
                <div className="flex items-center gap-2">
                  <Mail className="h-4 w-4 text-gray-500 dark:text-gray-400" />
                  <span>{user.email}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Phone className="h-4 w-4 text-gray-500 dark:text-gray-400" />
                  <span>{user.phone}</span>
                </div>
                <div className="my-2 h-px w-full bg-gray-200 dark:bg-gray-700" /> {/* Separator */}
                <div className="flex items-center gap-2">
                  <CalendarDays className="h-4 w-4 text-gray-500 dark:text-gray-400" />
                  <span>Date {user.birthday}</span>
                </div>
                <div className="flex gap-4 ">
                <div className="flex items-center gap-2">
                  <Award className="h-4 w-4 text-gray-500 dark:text-gray-400" />
                  <span>Status User</span> {user.phone == NUMBER_ADMIN ? (
                    <>
                    <div className="relative inline-block text-left">
                          {/* Bouton */}
                          <button
                            onClick={() => setOpen(!open)}
                            className="text-white hover:bg-green-800 justify-center focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 py-2 text-center inline-flex items-center dark:hover:bg-green-700 bg-green-700 dark:focus:ring-green-800"
                            type="button"
                          >
                           <span className=" bgColor text-gray-100 px-1 -mt-1 items-center justify-center rounded ">Guides</span>
                            <svg
                              className="w-2.5 h-2.5 ms-3"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 10 6"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="m1 1 4 4 4-4"
                              />
                            </svg>
                          </button>
                          {open && (
                            <div className="absolute  mt-2 z-10 bg-green-700 divide-y divide-gray-100 rounded-lg shadow-sm w-44 dark:bg-gray-700">
                              <ul
                                className="py-2 text-gray-50  dark:text-gray-200"
                                aria-labelledby="dropdownDefaultButton"
                              >
                                  <li>
                                    <a
                                      href="/mksp/guide/university"
                                      className="block px-4 py-2 hover:bg-green-600 dark:hover:bg-green-600 dark:hover:text-white"
                                    >
                                       Voir les Universités 
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      href="/mksp/choice-country"
                                      className="block px-4 py-2 hover:bg-green-600 dark:hover:bg-green-600 dark:hover:text-white"
                                    >
                                       Plan Premium
                                    </a>
                                  </li>
                              </ul>
                            </div>
                          )}
                        </div>
                    </>):(
                      <>
                        <span className=" text-gray-100 bg-green-700 px-2 py-1 items-center justify-center rounded ">    
                          FREE
                        </span>
                        <span className=" text-gray-100 bg-blue-700 px-2 py-1 items-center justify-center rounded ">    
                          <a href="/mksp/guide/university" className="font-medium customStyle  px-2 rounded  text-gray-200 hover:text-green-400 flex items-center gap-1">
                            Voir les Universités 
                          </a>
                        </span>
                      </>
                    )} 
                </div>
                {/* <div className="flex items-center gap-2">
                  <Award className="h-4 w-4 text-gray-500 dark:text-gray-400" />
                  <button onClick={logout} className="bg-red-700 text-gray-100 px-2 items-center justify-center rounded border-gray-700">Deconexion</button>
                </div> */}
                </div>
              </div>
            </div> 
          </div>
        </div>
      </div>
    </div>
    </div>
     </FadeIn>
    </>
    
   
    
  );
}



// import axios from 'axios';
// import { Mail, Phone, GraduationCap, BookOpen, CalendarDays, Award, User } from 'lucide-react'
// import { useEffect, useState } from 'react';
// import { API_BASE_URL } from '../../../../config/config';
// export default function ProfilUser() {
//      const [user, setUser] = useState(null);

//   useEffect(() => {
//     // 1ère option : lire depuis sessionStorage
//     const storedUser = sessionStorage.getItem("user");
//     if (storedUser) {
//       setUser(JSON.parse(storedUser));
//     } else {
//       // 2ème option : appeler l’API /me
//     axios.get(`${API_BASE_URL}/auth/me`, { withCredentials: true })
//   .then(res => {
//     console.log(res.data); // 🔍 Tu devrais voir { id: 2, email: "...", name: "naruto" }
//     setUser(res.data); // ✅ Pas res.data.user
//   })
//   .catch(err => console.error(err));
//     }
//   }, []);

//     console.log(res.data)


  

//   return (
//     <>

//   )
// }
